import { ICONS, type IconName } from './registry.js';

/**
 * 监色 icon：从 vedesign 的 SVG 文件 ?raw 导入。
 * 在 raw 上做最小处理：
 *  - 去掉 root <svg> 的 width/height（由 props 控制）
 *  - hex stroke / fill 转 currentColor（线条 icon 跟文字色联动）
 *
 * 文件类型彩色徽标（type=xxx）不走这个，遇到再加专门组件。
 */
function normalizeSvg(raw: string, size: number): string {
  let s = raw
    .replace(/<\?xml[^?]*\?>/g, '')
    .replace(/<!--[\s\S]*?-->/g, '')
    .replace(/<svg([^>]*?)\swidth="[^"]*"/, '<svg$1')
    .replace(/<svg([^>]*?)\sheight="[^"]*"/, '<svg$1')
    .replace(/stroke="#[0-9A-Fa-f]{3,8}"/g, 'stroke="currentColor"')
    .replace(/fill="#[0-9A-Fa-f]{3,8}"/g, 'fill="currentColor"')
    .replace(/stroke="black"/g, 'stroke="currentColor"')
    .replace(/fill="black"/g, 'fill="currentColor"');
  return s.replace('<svg', `<svg width="${size}" height="${size}" aria-hidden="true" focusable="false"`);
}

type Props = {
  name: IconName;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
};

export function Icon({ name, size = 18, className, style }: Props) {
  const html = normalizeSvg(ICONS[name], size);
  return (
    <span
      className={'ic' + (className ? ' ' + className : '')}
      style={{ width: size, height: size, display: 'inline-flex', flex: 'none', ...style }}
      // 资产来自仓库内 vedesign 真文件，不是外部输入，安全
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
